export const API_URLS = {
  AUTH: {
    SIGNUP: '/auth/signup',
    SIGNIN: '/auth/signin',
    FORGOT_PASSWORD: '/auth/forgot-password',
    VERIFY_OTP: '/auth/verify-otp',
    RESEND_OTP: '/auth/resend-otp',
    RESET_PASSWORD: '/auth/reset-password',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    GOOGLE_CONNECT: '/oauth/google/login',
    GOOGLE_CONNECT_STATUS: '/oauth/status',
    GOOGLE_CALLBACK: '/auth/google/callback',
    GOOGLE_LOGIN: '/auth/google/login',
    GOOGLE_DISCONNECT: '/oauth/google/disconnect'
  },
  USER: {
    UPDATE_PROFILE: () => `/profile`,
    DELETE_ACCOUNT: () => `/profile`,
    USER_STATS: (startDate, endDate) => `/dashboard?startDate=${startDate}&endDate=${endDate}`,
    COMPETITOR_CHANNELS: () => `/profile/competitor-channels`,
    SEARCH_COMPETITOR_CHANNELS: (query) => `/profile/competitor-channels/search?query=${query}&maxResults=1`,
    CHANNEL_COMPARISON: () => `/dashboard/comparison`,
    GENERATE_RESEARCH_REPORT: `/research/generate`,
    GET_RESEARCH_REPORT: (researchReportId) => `/research/${researchReportId}`,
    GET_RESEARCH: (researchId) => `/research/${researchId}`,
    GENERATE_OUTLINE: (researchReportId) => `/research/${researchReportId}/outline/generate`,
    GET_OUTLINE: (outlineId) => `/outline/${outlineId}`,
    GENERATE_SCRIPT: (outlineId) => `/outline/${outlineId}/script/generate`,
    GENERATE_RESEARCH_SCRIPT: (researchId) => `/research/${researchId}/script/generate`,
    UPDATE_RESEARCH_SCRIPT: (researchId, scriptIndex) => `/research/${researchId}/scripts/${scriptIndex}`,
    SHARE_SCRIPT: (scriptId) => `/scripts/${scriptId}/share`,
    UNSHARE_SCRIPT: (scriptId) => `/scripts/${scriptId}/move-to-scripts`,
    GET_TOPICS: `/topics/library`,
    GET_SCRIPTS: `/scripts`,
    GET_SCRIPT: (scriptId) => `/scripts/${scriptId}`,
    UPDATE_SCRIPT: (scriptId) => `/scripts/${scriptId}`,
    DELETE_SCRIPT: (scriptId) => `/scripts/${scriptId}`,
    EXPORT_SCRIPT: (scriptId) => `/scripts/${scriptId}/export`,
    DELETE_HOOK: (hookId) => `/outline/sequences/${hookId}`,
    UPDATE_HOOK: (hookId) => `/outline/sequences/${hookId}`,
    SEARCH_REFERENCE_VIDEOS: (query) => `/profile/reference-videos/search?query=${query}&maxResults=3`,
    CREATE_CREATOR_PROFILE: () => `/dashboard/creator-analysis`,
    GET_CREATOR_PROFILE: () => `/dashboard/creator-profile`,
    CHECK_VIDEO_DURATION: (videoUrl) => `/dashboard/check-video-duration?videoUrl=${encodeURIComponent(videoUrl)}`,
  },
};